import React, { useState, useEffect } from "react";
import "./basketballclicnic.css";
import home_background1 from "../../Assets/Images/home/banner.png";

import StaticPageHeaders from "../../Components/StaticPageHeaders";
import VideoBanner from "../../Components/BasketballClinic/VideoBanner/VideoBanner";
import Team from "../../Components/Team/Team";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";

import BasketBallClicnicBlock from "../../Components/BasketballClinic/BasketBallClicnicBlock/BasketBallClicnicBlock";

import img1 from "../../Assets/Images/BasketBallClinic/bbc1.png";
import img2 from "../../Assets/Images/BasketBallClinic/bbc2.png";
import img3 from "../../Assets/Images/BasketBallClinic/bbc3.png";
import bg_un from "../../Assets/Images/TeamWorkout/team_work_unlim.png";

import { InstructionsContextProvider } from "../../APIContext/InstructionsContext";
import { useNavigate } from "react-router-dom";
import Packages from "../../Components/BasketballClinic/Packages/Packages";
import SEO from "../../Components/SEO";
import EnquiryModal from "../../Components/EnquiryModal/EnquiryModal";

const SuccessStoriesBlocktwo = [
  {
    image: img1,
    name: "Shootin' School's Holy Family",
    des_2:
      "Ask not what you can do for Shootin' School, but what Shootin' School can do for you!",
    description:
      "2 action-packed days of basketball fun and games! At this clinic, during Mid-Winter Recess, we will work on ball-handling, shooting, passing, rebounding and more! Games, tournaments, and contests will be played after lunch! Beginners and experienced players can take advantage of these 2-Days of great instruction during the most important time of the basketball season.",
    benifitsText: "BENEFITS OF PRESIDENT’S DAY CLINIC",
    benifits: [
      "Additional Skill Development.",
      "Chance to win Prizes",
      "Camp Nurse on Site.",
      "Safe and Secure Environment and much, much more!",
      "Additional Game Play (3 on 3 or 4 on 4 tournaments) on Site.",
    ],
    orders: "left",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
  {
    image: img2,
    name: "Shootin' School's St. Patricks",
    des_2: "Spring Time! What better time of the year to work on your game?",
    description:
      "Our Spring clinic consists of 2 days of non-stop basketball! In the morning hours we focus in on Skill Development to take players games to the next level! We'll take a break for lunch and get right into games, tournaments and contests! This 2 day clinic will elevate your game, whether you are a beginner or experienced basketball player.",
    benifitsText: "BENEFITS OF SPRING CLINIC",
    benifits: [
      "Additional Skill Development.",
      "Chance to win Prizes",
      "Camp Nurse on Site.",
      "Safe and Secure Environment and much, much more!",
      "Additional Game Play (3 on 3 or 4 on 4 tournaments) on Site.",
    ],
    orders: "right",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
  {
    image: img3,
    name: "Shootin’ School’s Jumpshotz",
    des_2: "It's the most wonderful Clinic of the year!",
    description:
      "Don’t let your game get cold! During winter break, the Holiday Clinic is a great way to get players back into gear and ready for the 2nd half of the basketball season! These 2 days are fun-filled with skill development, games, tournaments, contests and more! Beginners and experienced players can both benefit from this clinic!",
    benifitsText: "BENEFITS OF SPRING CLINIC",
    benifits: [
      "Additional Skill Development.",
      "Chance to win Prizes",
      "Camp Nurse on Site.",
      "Safe and Secure Environment and much, much more!",
      "Additional Game Play (3 on 3 or 4 on 4 tournaments) on Site.",
    ],
    orders: "left",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
];

const BasketBallInstructions = () => {
  const navigate = useNavigate();
  const images = [home_background1];
  const [showModal, setShowModal] = useState(false);

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);
  return (
    // <iframe width="560" height="315" src="https://www.youtube.com/embed/mHkGB3nzy58?si=yP2ZthVNs7bXV5nm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    <>
      <SEO
        title="Clinics - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/clinics/"
      />

      <div className="bc-page">
        <StaticPageHeaders title="BasketBall Clinics" />
        <VideoBanner
          videoUrl="https://www.youtube.com/embed/mHkGB3nzy58?si=yP2ZthVNs7bXV5nm"
          heading="Staten island’s Premier Basketball Instruction"
          buttonText="Inquiry now"
          buttonLink="#"
          setShowModal={setShowModal}
        />

        <InstructionsContextProvider>
          <Packages data={SuccessStoriesBlocktwo} setShowModal={setShowModal} />
        </InstructionsContextProvider>

        <div className="bc-container">
          <div className="bc-sss-layout">
            <div className="sss-grid" style={{ paddingTop: "30px" }}>
              {SuccessStoriesBlocktwo.map((successstory, i) => (
                <BasketBallClicnicBlock
                  key={i}
                  image={successstory.image}
                  name={successstory.name}
                  description={successstory.description}
                  benifitsText={successstory.benifitsText}
                  benifits={successstory.benifits}
                  order={successstory.orders}
                  buttonText={successstory.buttonText}
                  buttonLink={successstory.buttonLink}
                  setShowModal={setShowModal}
                />
              ))}
            </div>
          </div>
        </div>

        <UnlimitedBannerCom brValue={1.28} />
        <Gallery />
        <Sponsors />
        {showModal && <EnquiryModal onClose={() => setShowModal(false)} />}
      </div>
    </>
  );
};

export default BasketBallInstructions;
